import { useParams } from 'react-router-dom';

import { profileData } from '../../../Utils/home/feeds/dummyData';
import {
  LoadingParticipationTemplate,
  ParticipationTemplateError,
} from '../../../atomic/pages/ParticipationTemplate';
import { ParticipationTemplateErrorTypes } from '../../../atomic/pages/ParticipationTemplate/types';
import { APP_URL } from '../../../config';
import { ComponentStatus } from '../../../interfaces/component';
import { useGetFlowTemplate } from '../../../queries/Flows/Template';
import FlowsTemplatePreviewController from '../FlowsTemplatePreviewController';

const FlowsPreviewController = () => {
  const { templateId } = useParams<{ templateId: string }>();

  const {
    isError,
    data: flowTemplateData,
    isLoading: isFlowTemplateLoading,
  } = useGetFlowTemplate(templateId);

  const handleOnUseTemplateClick = () => {
    const { searchParams } = new URL(window.location.href);
    const url = new URL(`${APP_URL}flows/editor?template=${templateId}`);
    searchParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        url.searchParams.append(key, value);
      }
    });

    window.open(url.toString(), '_blank');
  };

  if (!isFlowTemplateLoading && isError) {
    return (
      <ParticipationTemplateError
        flowId=""
        isFullScreen
        member={profileData.member}
        headerStatus={ComponentStatus.LOADED}
        flowHeaderContent={{
          TitleContent: <></>,
          DescriptionContent: '',
        }}
        templateError={ParticipationTemplateErrorTypes.INVALID_FLOW_ID}
      />
    );
  }

  if (!isFlowTemplateLoading && flowTemplateData) {
    return (
      <FlowsTemplatePreviewController
        isFullScreen
        profileInfo={profileData}
        showCloseModalOption={false}
        flowTemplateData={flowTemplateData}
        onUseTemplateClick={handleOnUseTemplateClick}
      />
    );
  }

  return (
    <LoadingParticipationTemplate
      flowId=""
      isFullScreen
      showCloseOption={false}
      member={profileData.member}
      headerStatus={ComponentStatus.LOADING}
      flowHeaderContent={{ DescriptionContent: '', TitleContent: '' }}
    />
  );
};

export default FlowsPreviewController;
